import styles from "./CopyInput.module.scss";
import cn from "classnames";
// import { ChangeEvent } from "react";

import { ReactComponent as CopySvg } from "@assets/svg/copy.svg";

interface IInputProps {
  name: string;
  value: any;
  label?: String;
  placeholder?: string;
  readOnly?: boolean;
  // eslint-disable-next-line no-unused-vars
  onCopy?: null | (() => void);
  className?: string;
}
export default function CopyInput({
  className = "",
  label = "",
  onCopy = null,
  ...rest
}: IInputProps): JSX.Element {
  const inputClasses: string = cn(styles.container, className);
  return (
    <div className={inputClasses}>
      {label && <label>{label}</label>}
      <div className={styles.row}>
        <input type="text" disabled {...rest} />

        {onCopy && (
          <button className={styles.copy} onClick={onCopy}>
            <span className={styles.icon}>
              <CopySvg />
            </span>
          </button>
        )}
      </div>
    </div>
  );
}
